import app from 'flarum/forum/app';
import { extend } from 'flarum/common/extend';
import humanTime from 'flarum/common/utils/humanTime';
import extractText from 'flarum/common/utils/extractText';
import Button from 'flarum/common/components/Button';
import Link from 'flarum/common/components/Link';
import Tooltip from 'flarum/common/components/Tooltip';
import Discussion from 'flarum/common/models/Discussion';
import DiscussionControls from 'flarum/forum/utils/DiscussionControls';
import DiscussionListItem from 'flarum/forum/components/DiscussionListItem';

import config from '../common/config';
import AnonymousAvatar from './components/AnonymousAvatar';

export default function () {
  extend(DiscussionListItem.prototype, 'view', function (vdom) {
    // @ts-ignore
    const discussion = this.attrs.discussion as Discussion;

    if (!discussion.attribute('isAnonymous')) {
      return;
    }

    vdom.children.forEach((vdom) => {
      if (!vdom || !vdom.attrs || !vdom.attrs.className || vdom.attrs.className.indexOf('DiscussionListItem-content') === -1) {
        return;
      }

      vdom.children.forEach((vdom) => {
        if (!vdom || vdom.tag !== Tooltip) {
          return;
        }

        vdom.attrs.text = app.translator.trans('core.forum.discussion_list.started_text', {
          username: app.translator.trans(`${config.module.id}.lib.userMeta.username`),
          ago: humanTime(discussion.createdAt()),
        });

        vdom.children.forEach((vdom) => {
          if (!vdom || vdom.tag !== Link) {
            return;
          }

          vdom.attrs.href = null;

          vdom.children = [<AnonymousAvatar />];
        });
      });
    });
  });

  extend(DiscussionControls, 'moderationControls', function (items, discussion) {
    if (discussion.attribute('canDeAnonymize')) {
      items.add(
        'deanonymize',
        <Button
          icon="fas fa-user-secret"
          onclick={() => {
            if (!confirm(extractText(app.translator.trans(`${config.module.id}.forum.discussionControls.deanonymizeConfirmation`)))) {
              return;
            }

            discussion
              .save({
                isAnonymous: false,
              })
              .then(() => {
                m.redraw();
              });
          }}
        >
          {app.translator.trans(`${config.module.id}.forum.discussionControls.deanonymize`)}
        </Button>
      );
    }

    if (discussion.attribute('canAnonymize')) {
      items.add(
        'anonymize',
        <Button
          icon="fas fa-user-secret"
          onclick={() => {
            if (!confirm(extractText(app.translator.trans(`${config.module.id}.forum.discussionControls.anonymizeConfirmation`)))) {
              return;
            }

            discussion
              .save({
                isAnonymous: true,
              })
              .then(() => {
                m.redraw();
              });
          }}
        >
          {app.translator.trans(`${config.module.id}.forum.discussionControls.anonymize`)}
        </Button>
      );
    }
  });
}
